module.exports = __webpack_public_path__ + "img/currie-cup-logo-colour.6a0e55ac.png";